import { Tag } from "@sprout/tag.tsx";
import LoadingSkeleton from "./loading_skeleton.tsx";

type Props = {
  loading?: boolean;
  location?: string;
  payRange?: string;
};
const Tags = ({ loading, location, payRange }: Props) => {
  return loading ? (
    <LoadingSkeleton className="h-4 w-[120px]" />
  ) : (
    <>
      {location && <Tag label={location} truncate={false} maxWidth="max-w-full" />}
      {payRange && <Tag label={payRange} truncate={false} maxWidth="max-w-full" />}
    </>
  );
};

export default Tags;
